import { atomWithStorage } from "jotai/utils";
import { STORED_ATOM_KEYS } from "../constants";
import {
  OAuthResponse,
  UsersSvcUser,
} from "@nestcoinco/hyper-api-gateway-api-client";

export const userAtom = atomWithStorage<OAuthResponse | null>(
  STORED_ATOM_KEYS.USER,
  null,
  undefined,
  { getOnInit: true }
);
userAtom.debugLabel = "user-atom-stored";

export const userProfileAtom = atomWithStorage<UsersSvcUser | null>(
  STORED_ATOM_KEYS.USER_PROFILE,
  null,
  undefined,
  { getOnInit: true }
);
userProfileAtom.debugLabel = "user-profile-stored";

export const userHasAllowedLocationAtom = atomWithStorage<boolean | null>(
  STORED_ATOM_KEYS.USER_HAS_ALLOWED_LOCATION,
  null,
  undefined,
  { getOnInit: true }
);
userHasAllowedLocationAtom.debugLabel = "user-has-allowed-location-stored";

export const userHasSubscribedAtom = atomWithStorage<boolean | null>(
  STORED_ATOM_KEYS.USER_HAS_SUBSCRIBED,
  false,
  undefined,
  { getOnInit: true }
);
userHasSubscribedAtom.debugLabel = "user-has-subscribed-stored";

export const userCustomAvatarAtom = atomWithStorage<string | null>(
  STORED_ATOM_KEYS.USER_CUSTOM_AVATAR,
  null,
  undefined,
  { getOnInit: true }
);
userCustomAvatarAtom.debugLabel = "user-custom-avatar-stored";
